import type { FaireProductEntity } from "../../entity_types/product";

export const p_wev672x3w3: FaireProductEntity = {
  token: "p_wev672x3w3",
  type: "product",
  name: "Butter Dish with Lid 6.5\"L w/ Butter Knife Plum Blossoms Design (4/32)",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/5aad31c35338744959dea15cf2a4edf98f93716f5bc2b88befd2e9ad077596d0.png",
  galleryImageUrls: [],
  priceDollars: 10,
  description: "Size: 6.5\"L x 3.8\"W x 3\"H\n\nMaterial: Ceramic with Bamboo Lid\n\nCase Pack: 32\n\nOrigin: China\n",
  tags: [],
  msrpDollars: 22.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:46.246Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
